"use strict";

require("core-js/modules/es.object.define-property.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.array.concat.js");
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRadioGroup = require("react-radio-group");
var _index = require("./index");
var _radioGroup = require("./radioGroup");
var _formElements = require("@evidation/form-elements");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _excluded = ["name", "value", "onChange", "interface", "label", "smallLabel", "required", "disabled", "answers"];
var Container = _styledComponents["default"].div.withConfig({
  displayName: "radioGroupStandard__Container"
})(["display:flex;flex-flow:column nowrap;"]);
var Holder = _styledComponents["default"].div.withConfig({
  displayName: "radioGroupStandard__Holder"
})(["color:rgba(64,64,64,1);cursor:", ";margin:5px;padding-top:10px;label{cursor:inherit !important;}"], function (p) {
  return p.disabled ? 'default' : 'pointer';
});
var RadioGroup = function RadioGroup(_ref) {
  var name = _ref.name,
    value = _ref.value,
    onChange = _ref.onChange,
    intf = _ref["interface"],
    label = _ref.label,
    smallLabel = _ref.smallLabel,
    required = _ref.required,
    disabled = _ref.disabled,
    _ref$answers = _ref.answers,
    answers = _ref$answers === void 0 ? [] : _ref$answers,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_index.FieldWrapper, (0, _extends2["default"])({
    "data-test-id": intf
  }, rest), /*#__PURE__*/_react["default"].createElement(_formElements.InputLabel, {
    label: label
  }, /*#__PURE__*/_react["default"].createElement(_radioGroup.ReactRadioGroup, {
    className: "".concat(intf, "-radio"),
    name: name,
    selectedValue: value || ''
  }, /*#__PURE__*/_react["default"].createElement(Container, null, answers.map(function (answer) {
    return /*#__PURE__*/_react["default"].createElement(Holder, {
      key: "".concat(name, "_").concat(answer.value),
      disabled: disabled,
      onClick: function onClick() {
        return !disabled && onChange(answer.value);
      }
    }, /*#__PURE__*/_react["default"].createElement(_reactRadioGroup.Radio, {
      id: "".concat(name, "_").concat(answer.value),
      value: answer.value,
      disabled: disabled,
      readOnly: true
    }), /*#__PURE__*/_react["default"].createElement("label", {
      htmlFor: "".concat(name, "_").concat(answer.value)
    }, answer.label));
  })))));
};
RadioGroup.defaultProps = {
  meta: {},
  answerLabels: []
};
RadioGroup.propTypes = {
  name: _propTypes["default"].string.isRequired,
  onChange: _propTypes["default"].func.isRequired,
  label: _propTypes["default"].string,
  answerLabels: _propTypes["default"].array.isRequired
};
var _default = exports["default"] = RadioGroup;